import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import Text from 'components/Text'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import {
  isMobileScreenViewportSelect,
  isSmallMobileScreenViewportSelect
} from 'modules/viewport/selectors/index.js'

const FONT_SIZE = '11px'
const FONT_SIZE_MOBILE = '9px'
const FONT_SIZE_SMALL_MOBILE = '7px'
const HEIGHT = '24px'
const PADDING = '6px 10px'
const PADDING_MOBILE = '3px 7px'
const PADDING_SMALL_MOBILE = '2px 6px'

/**
 * Reusable chip-style button component with border and border-radius
 *
 * @param {string} title - Text to display in the button
 * @param {function} onClick - Click handler
 * @param {boolean} disabled - Whether the button is disabled
 * @param {boolean} showArrow - Whether to show the dropdown arrow (defaults to true when onClick is provided)
 * @param {object} style - Additional styles to apply
 * @returns {JSX.Element}
 */
export default function ChipButton ({
  title,
  onClick,
  disabled = false,
  showArrow,
  style = {}
}) {
  const isSmallMobile = useSelector(isSmallMobileScreenViewportSelect)
  const isMobile = useSelector(isMobileScreenViewportSelect)
  const shouldShowArrow = showArrow !== undefined ? showArrow : !!onClick

  let fontSize
  let padding
  if (isSmallMobile) {
    fontSize = FONT_SIZE_SMALL_MOBILE
    padding = PADDING_SMALL_MOBILE
  } else if (isMobile) {
    fontSize = FONT_SIZE_MOBILE
    padding = PADDING_MOBILE
  } else {
    fontSize = FONT_SIZE
    padding = PADDING
  }

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '11px',
        cursor: disabled ? 'default' : 'pointer',
        padding,
        border: '1px solid #E0E0E0',
        borderRadius: '12px',
        backgroundColor: disabled ? '#F6F6F6' : '#FFFFFF',
        transition: 'all 0.2s ease',
        height: HEIGHT,
        opacity: disabled ? 0.6 : 1,
        ...style
      }}
    >
      <Text
        c='#151D21'
        fw='510'
        fs={fontSize}
      >
        {title}
      </Text>

      {shouldShowArrow && (
        <ArrowDownIcon
          style={{
            fill: '#676767',
            width: '10.29px',
            marginLeft: '4.84px'
          }}
        />
      )}
    </button>
  )
}
